import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import Modal from 'react-modal';
import { Button, Tooltip } from '@material-tailwind/react';
import { getValidationErrors } from '../shared/Input/common';
import { AlertColors, AlertTypes } from '../../models/Enums';
import useIsMobile from '../../hooks/useIsMobile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import './style.css'
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import http from '../../services/httpRequest';

interface ModalFormProps {
    field: string
    register?: any
    setValue?: any
    rules?: any
    errors?: any
}


const customStyles = {
    content: {
        margin: 'auto',
        width: '500px',
        height: 'Fit-content',
        borderRadius: '15px',
    }
};

const Icon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="h-5 w-5"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
            />
        </svg>
    )

}

function ModalForm({
    field,
    register,
    setValue,
    rules = {},
    errors = null,
}: ModalFormProps) {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [fileName, setFileName] = useState('');
    const fileInputRef = useRef<HTMLInputElement>(null);
    const validationError = errors && getValidationErrors(errors, field, "", rules);
    const isMobile = useIsMobile();

    const onDrop = useCallback((acceptedFiles: File[]) => {
        setFile(acceptedFiles[0]);
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    function openModal() {
        setIsOpen(true);
    }

    function openFilePicker() {
        fileInputRef.current?.click();
    }

    function closeModal() {
        setIsOpen(false);
    }

    function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
        const file = event.target.files?.[0];
        if (file) {
            setFile(file);
        }
    }

    const setFile = (file: File) => {
        const fileSizeInKB = file.size / 1024;
        if (fileSizeInKB > 6144) {
            http.apiResponse.showError('El archivo es demasiado grande', AlertTypes.WARNING);
            return;
        }
        setValue(field, [file]);
        setFileName(file.name);
        closeModal();
    }

    const getRules = () => {
        if (rules) {
            rules['required'] = false;
        }
        return rules;
    };

    useEffect(() => {
        closeModal();
    }, [isMobile]);

    return (
        <div className='form-input-modal'>
            <div className='btn-container'>
                <Tooltip
                    content="Sube tu archivo de proyecto en formato PDF"
                    animate={{
                        mount: { scale: .8, y: 0 },
                        unmount: { scale: 0, y: 25 },
                    }}
                >
                    <Button color={fileName ? (AlertColors.SUCCESS) : (AlertColors.WARNING)} variant="gradient" className="flex items-center gap-3" placeholder='' onClick={isMobile ? (openFilePicker) : (openModal)} fullWidth>
                        {!fileName && Icon()}
                        {fileName && <FontAwesomeIcon icon={faCheck} size='xl' />}
                        <p className='upload-btn'>{fileName || 'Selecciona un archivo'}</p>
                    </Button>
                </Tooltip>
                <input {...getInputProps()} {...register(field, { ...getRules() })} ref={fileInputRef} onChange={handleFileChange} accept='.pdf' />
                <label className='label-input-error'> {validationError ? (validationError) : ("")}</label>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div {...getRootProps()} onClick={()=>{}} className="border-dashed border-4 border-gray-600 p-10 " style={{ borderRadius: '10px', background: isDragActive ? '#dadada' : 'white' }}>
                    <div className='modal-content'>
                        <div className='modal-message'>
                            <FontAwesomeIcon icon={faFilePdf} size='2xl' />
                            <p>{fileName ? ("Seleccionado: " + fileName) : 'Arrastra y suelta algunos archivos aquí, o haz clic para seleccionar archivos'}</p>
                        </div>
                        <p>(max. 6 MB)</p>
                        <Button variant="gradient" className="flex items-center gap-3 " placeholder='' onClick={openFilePicker}>
                            {Icon()}
                            <p className='upload-btn'>Buscar Archivo</p>
                        </Button>
                    </div>
                </div>

            </Modal>
        </div>
    );
}

export default ModalForm;
